// Basketball team primary colours (from the design handoff bb-data.jsx). Per-team
// reference data — used for the team-coloured badges on Slate / Night Shift game
// cards. Not a design token (per-team data). Falls back to neutral grey.

export const BB_TEAM_COLORS: Readonly<Record<string, string>> = {
  LAL: "#552583", BOS: "#007a33", DEN: "#0e2240", OKC: "#007ac1",
  PHI: "#006bb6", MIA: "#98002e", MIL: "#00471b", NYK: "#f58426",
  REA: "#febd11", BAR: "#a50034", BRZ: "#e8702a", MEL: "#1a1a1a",
  WAS: "#002b5c", CHA: "#1d1160", SAS: "#c4ced4", DAL: "#00538c",
  DET: "#1d428a", TOR: "#ce1141", MIN: "#236192", NOP: "#85714d",
  PHX: "#e56020", POR: "#e03a3e", UTA: "#002b5c", GSW: "#1d428a",
  CLE: "#860038", SAC: "#5a2d81", LAC: "#c8102e", ORL: "#0077c0",
  HOU: "#ce1141", MEM: "#5d76a9", IND: "#002d62", ATL: "#e03a3e",
  BKN: "#000000", CHI: "#ce1141",
};

export function teamColor(code: string | null | undefined): string {
  if (!code) return "#888888";
  return BB_TEAM_COLORS[code.toUpperCase()] ?? "#888888";
}

/** First 3 letters of a team name, uppercased — a code for badge text + colour
 *  lookup when the RPC gives a team name rather than a code. */
export function teamCode(name: string | null | undefined): string {
  if (!name) return "—";
  const parts = name.trim().split(/\s+/);
  const last = parts[parts.length - 1] ?? name;
  return last.slice(0, 3).toUpperCase();
}
